import React, { Fragment, useState } from 'react';
import List from "@mui/material/List";
import ListItem from "@mui/material/List";
import Collapse from "@mui/material/Collapse";
import { NavLink } from "react-router-dom";
import { useLanguage } from '../../context/LanguageContext';
import './style.css';

const MobileMenu = () => {
    const { lang, setLang, t } = useLanguage();
    const [openId, setOpenId] = useState(0);
    const [menuActive, setMenuState] = useState(false);

    const menus = [
        { id: 1, title: t('nav.home'), link: '/' },
        { id: 2, title: t('nav.about'), link: '/about' },
        { id: 3, title: t('nav.products'), link: '/shop' },
        { id: 4, title: t('nav.forms'), link: '/bilgi-formlari' },
        { id: 6, title: t('nav.contact'), link: '/contact' },
    ];

    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }

    return (
        <div>
            <div className={`mobileMenu ${menuActive ? "show" : ""}`}>
                <div className="menu-close">
                    <div className="clox" onClick={() => setMenuState(!menuActive)}><i className="ti-close"></i></div>
                </div>

                {/* Mobil dil seçici */}
                <div style={{ display: 'flex', gap: '10px', padding: '15px 20px 5px' }}>
                    <button
                        onClick={() => setLang('tr')}
                        style={{
                            background: 'none', border: 'none', padding: 0, cursor: 'pointer',
                            borderRadius: '50%', overflow: 'hidden', width: '36px', height: '36px',
                            opacity: lang === 'tr' ? 1 : 0.4,
                            boxShadow: lang === 'tr' ? '0 0 0 2px #ff5b2e' : 'none',
                        }}
                    >
                        <img src="https://flagcdn.com/w40/tr.png" alt="TR"
                            style={{ width: '36px', height: '36px', objectFit: 'cover', borderRadius: '50%' }} />
                    </button>
                    <button
                        onClick={() => setLang('en')}
                        style={{
                            background: 'none', border: 'none', padding: 0, cursor: 'pointer',
                            borderRadius: '50%', overflow: 'hidden', width: '36px', height: '36px',
                            opacity: lang === 'en' ? 1 : 0.4,
                            boxShadow: lang === 'en' ? '0 0 0 2px #ff5b2e' : 'none',
                        }}
                    >
                        <img src="https://flagcdn.com/w40/gb.png" alt="EN"
                            style={{ width: '36px', height: '36px', objectFit: 'cover', borderRadius: '50%' }} />
                    </button>
                </div>

                <ul className="responsivemenu">
                    {menus.map((item, mn) => (
                        <ListItem className={item.id === openId ? 'active' : null} key={mn}>
                            {item.submenu ? (
                                <Fragment>
                                    <p onClick={() => setOpenId(item.id === openId ? 0 : item.id)}>
                                        {item.title}
                                        <i className={item.id === openId ? 'fa fa-angle-up' : 'fa fa-angle-down'}></i>
                                    </p>
                                    <Collapse in={item.id === openId} timeout="auto" unmountOnExit>
                                        <List className="subMenu">
                                            <Fragment>
                                                {item.submenu.map((submenu, i) => (
                                                    <ListItem key={i}>
                                                        <NavLink onClick={ClickHandler} className="active" to={submenu.link}>{submenu.title}</NavLink>
                                                    </ListItem>
                                                ))}
                                            </Fragment>
                                        </List>
                                    </Collapse>
                                </Fragment>
                            ) : (
                                <NavLink className="active" to={item.link}>{item.title}</NavLink>
                            )}
                        </ListItem>
                    ))}
                </ul>
            </div>

            <div className="showmenu mobail-menu" onClick={() => setMenuState(!menuActive)}>
                <button type="button" className="navbar-toggler open-btn">
                    <span className="icon-bar first-angle"></span>
                    <span className="icon-bar middle-angle"></span>
                    <span className="icon-bar last-angle"></span>
                </button>
            </div>
        </div>
    )
}

export default MobileMenu;
